export enum NotificationType {
  Success = 'success',
  NoSingleUser = 'noSingleUser',
  EnterSearchUser = 'enterSearchUser',
}

export enum UserSelectMode {
  ASSIGNMENT = 'ASSIGNMENT',
  RETURN = 'RETURN',
  UPGRADE = 'UPGRADE',
}

export enum ItemAssignmentSelectMode {
  CAMERA_SCAN = 'item_select_mode_scan_items',
  HAND_SCANNER_SCAN = 'item_select_mode_hand_scanner_scan_items',
  SELECT_CATEGORY = 'item_select_mode_select_quantities',
}

export const ItemAssignmentScannersModes = [
  ItemAssignmentSelectMode.CAMERA_SCAN,
  ItemAssignmentSelectMode.HAND_SCANNER_SCAN,
];

export interface Notification {
  message: string | null;
  icon: string | null;
}

export type Notifications = {
  [key in NotificationType]: Notification;
};
